/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import React, { memo } from 'react';
import { SidebarBoundary } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/ui/sidebar-boundary/index.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import { Skeleton } from './skeleton/index.tsx';

const LazySidebarContent = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "async-jira-navigation-apps-sidebar-nav4-sidebar-personal-settings" */ './main.tsx'
		),
	{
		includeInShellOnlySsrBundle: true,
		entryFsSsrLiftImportToModule: true,
	},
);

const AsyncSidebar = (): React.JSX.Element => (
	<SidebarBoundary
		id="nav4.sidebar.personal-settings"
		packageName="jiraNavigationAppsSidebarNav4PersonalSettings"
		ufoName="nav4.sidebar.personal-settings"
	>
		<Placeholder name="nav4.sidebar.personal-settings" fallback={<Skeleton />}>
			<LazySidebarContent />
		</Placeholder>
	</SidebarBoundary>
);

const ExportedComponent: React.MemoExoticComponent<() => React.JSX.Element> = memo(AsyncSidebar);
export default ExportedComponent;
